import React, { FC, SyntheticEvent, useEffect, useState } from 'react';
import Paper, { PaperProps } from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import { TreeView } from '@mui/x-tree-view/TreeView';

import { getChildDepartmentIdsToLevel, getDepartmentById } from 'src/features/departments';
import { ChevronDownIcon, ChevronUpIcon } from 'src/shared/components';

import { DepartmentSelectorPaperExtraProps } from './DepartmentSelector.types';

interface Props extends PaperProps, DepartmentSelectorPaperExtraProps {}

export const DepartmentSelectorPaper: FC<Props> = ({ departments, onDepartmentChange, children, ...props }) => {
  const theme = useTheme();

  const [expanded, setExpanded] = useState<string[]>([]);

  const handleSelect = (ev: SyntheticEvent, nodeIds: string[]) => {
    if (!departments) {
      return;
    }

    ev.preventDefault();

    if (
      ev.target instanceof Element &&
      (ev.target.nodeName === 'svg' ||
        ev.target.nodeName === 'path' ||
        ev.target.className === 'MuiTreeItem-iconContainer')
    ) {
      return;
    }

    const selectedId = nodeIds[0];
    const selectedDepartment = getDepartmentById(departments, selectedId);
    if (!selectedDepartment) return;

    onDepartmentChange?.(selectedDepartment);
  };

  const handleToggle = (ev: SyntheticEvent, nodeIds: string[]) => {
    if (
      ev.target instanceof Element &&
      (ev.target.nodeName === 'svg' ||
        ev.target.nodeName === 'path' ||
        ev.target.className === 'MuiTreeItem-iconContainer')
    ) {
      setExpanded(nodeIds);
    }
  };

  useEffect(() => {
    if (!departments?.length) {
      return;
    }

    setExpanded(getChildDepartmentIdsToLevel(departments, departments.length > 1 ? 0 : 1));
  }, [departments]);

  return (
    <Paper {...props}>
      <TreeView
        defaultCollapseIcon={<ChevronUpIcon color={theme.palette.action.active} />}
        defaultExpandIcon={<ChevronDownIcon color={theme.palette.action.active} />}
        multiSelect
        expanded={expanded}
        onNodeSelect={handleSelect}
        onNodeToggle={handleToggle}
      >
        {children}
      </TreeView>
    </Paper>
  );
};
